import { Injectable, TemplateRef } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { EventType } from '@azure/msal-browser';
import { Router, ActivatedRoute, RoutesRecognized, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from "@angular/router";
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs/internal/Observable';
import { share } from 'rxjs/internal/operators/share';
import { AuthManager } from './authmanager';
import { AuthState } from "./models/AuthState.enum";
//import { Headers, RequestOptions, Response, RequestMethod, URLSearchParams } from '@angular/http';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Popup } from './models/popup';
import { filter } from 'rxjs/internal/operators/filter';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { take } from 'rxjs/internal/operators/take';
import { debounce, isEqual, kebabCase, memoize, uniqBy, cloneDeep, isEmpty } from "lodash-es"
import { DomSanitizer } from '@angular/platform-browser';
import html2Canvas from 'html2canvas';
import version from './../assets/latestVersion.json';

import {
  faPowerOff, faUserCircle, faBars, faSquare, faPuzzlePiece, faVideo, faFilm, faConciergeBell, faShare, faFilePdf, faShareAlt, faEye, faTimes, faDollarSign,
  faMapMarker, faBuilding, faSync, faLocationArrow, faCheck, faIndustry, faTruck, faBug, faReplyAll, faSave, faUpload, faTrash, faUsers, faPlay,
  faBullhorn, faComment, faShoppingCart, faCircle, faCheckCircle, faEnvelope, faSearch, faUserPlus, faWindowClose, faSortUp, faSortDown, faPlus, faCartPlus, faCartArrowDown, faArrowDown, faArrowUp, faArrowLeft, faArrowRight, faCheckSquare, faFilter, faExternalLinkSquareAlt, faPrint, faHome, faPaperclip, faPencilAlt, faExclamationCircle, faQuestion, faFlagCheckered, faBan, faFileWord, faFileImage, faFile, faFileAlt, faSpinner, faArrowAltCircleRight, faUndo, faUndoAlt, faRedo, faLock, faCog, faArrowCircleUp, faRandom, faCaretDown, faCaretUp, faCaretLeft, faCaretRight, faMinus, faExpand, faDownload, faCut, faUser
} from '@fortawesome/free-solid-svg-icons';
import { faFacebookSquare, faLinkedin, faTwitterSquare, faWpforms, faYoutubeSquare, faInstagramSquare, faPinterestSquare, faHouzz } from '@fortawesome/free-brands-svg-icons'
import { faSquare as faSquareThin, faCircle as faCircleThin, faPlusSquare, faMinusSquare } from '@fortawesome/free-regular-svg-icons';
import { CmsPipe } from './pipes/cms.pipe';
import { CsvHeader } from './models/csvHeader';




@Injectable({
  providedIn: 'root'
})
export class DataService {

  //API_ROOT = 'https://localhost:7098';
  API_ROOT = environment.apiUrl;
  version = version.version; // 'Version 2019.12.05_17.15';
  updatingVersion = false;

  modelReady = false;
  am: AuthManager;
  ajaxCount = 1; //will be cleared by authmanager
  debugAjax: boolean = false;
  appRef: any = {};
  cartRef: any = {};
  trimrenderRef: any = {};
  trimfcteditRef: any = {};
  cutlistRef: any = {};
  debugVisible = false;
  runLog: string[] = [];
  demoMode: boolean = false;
  logFlags: string[] = ["OFFERING_ID"];
  currentRoute: string = "/";
  targetAction: string = "";
  lastAction: any;
  nextAction: any;
  showFilters: boolean = true;

  copyrightYear = new Date().getFullYear();

  colorCollection: any[] = [];

  model: any = {
    accountInfo: null,
    ShipMode: {},
    ShipTo: {},
    SoldTo: {},
    imageZoomUrl: "",
    user: {
      authState: AuthState.Initial,
      token: null,
      info: null,
    },
    shipToList: {
      "routes": [],
      "willcall": [],
      "panels": [],
      "jobsitePreApproved": []
    },
    jobSite: false,
    jobSiteForm: this.initJobsite(),
    targetPanel: null
  };

  faPowerOff = faPowerOff;
  faUserCircle = faUserCircle;
  faBars = faBars;
  faSquare = faSquare;
  faWpforms = faWpforms;
  faPuzzlePiece = faPuzzlePiece;
  faVideo = faVideo;
  faFilm = faFilm;
  faDollarSign = faDollarSign;
  faConciergeBell = faConciergeBell;
  faShare = faShare;
  faShareAlt = faShareAlt;
  faFilePdf = faFilePdf;
  faFacebookSquare = faFacebookSquare;
  faTwitterSquare = faTwitterSquare;
  faYoutube = faYoutubeSquare;
  faInstagram = faInstagramSquare;
  faPintrest = faPinterestSquare;
  faHouzz = faHouzz;
  faLinkedIn = faLinkedin;
  faEye = faEye;
  faTimes = faTimes;
  faMapMarker = faMapMarker;
  faBuilding = faBuilding;
  faSync = faSync;
  faLocationArrow = faLocationArrow;
  faCheck = faCheck;
  faIndustry = faIndustry;
  faTruck = faTruck;
  faBug = faBug;
  faReplyAll = faReplyAll;
  faSave = faSave;
  faUpload = faUpload;
  faTrash = faTrash;
  faUsers = faUsers;
  faPlay = faPlay;
  faSortUp = faSortUp;
  faSortDown = faSortDown;
  faCircleThin = faCircleThin;
  faCircle = faCircle;
  faUserPlus = faUserPlus;
  faSearch = faSearch;
  faWindowClose = faWindowClose;
  faCheckCircle = faCheckCircle;
  faEnvelope = faEnvelope;
  faPlus = faPlus;
  faMinus = faMinus;
  faShoppingCart = faShoppingCart;
  faComment = faComment;
  faBullhorn = faBullhorn;
  faCartPlus = faCartPlus;
  faCartArrowDown = faCartArrowDown;
  faArrowDown = faArrowDown;
  faArrowUp = faArrowUp;
  faArrowLeft = faArrowLeft;
  faArrowRight = faArrowRight;
  faCheckSquare = faCheckSquare;
  faSquareThin = faSquareThin;
  faFilter = faFilter;
  faExternalLinkSquareAlt = faExternalLinkSquareAlt;
  faPlusSquare = faPlusSquare;
  faMinusSquare = faMinusSquare;
  faPrint = faPrint;
  faHome = faHome;
  faPaperclip = faPaperclip;
  faCut = faCut;
  faPencilAlt = faPencilAlt;
  faExclamationCircle = faExclamationCircle;
  faQuestion = faQuestion;
  faFlagCheckered = faFlagCheckered;
  faBan = faBan;
  faFileWord = faFileWord;
  faFileImage = faFileImage;
  faFile = faFile;
  faFileAlt = faFileAlt;
  faSpinner = faSpinner;
  faUndo = faUndo;
  faRedo = faRedo;
  faLock = faLock;
  faCog = faCog;
  faArrowCircleUp = faArrowCircleUp;
  faRandom = faRandom;
  faCaretDown = faCaretDown;
  faCaretUp = faCaretUp;
  faCaretLeft = faCaretLeft;
  faCaretRight = faCaretRight;
  faExpand = faExpand;
  faDownload = faDownload;
  faUser = faUser;

  screenshotBlob: Blob;
  errorReportInProgress = false;
  errorMsg: any = {};


  isEqual = isEqual;
  uniqBy = uniqBy;
  memoize = memoize;
  kebabCase = kebabCase;
  isNaN = isNaN;
  debounce = debounce;

  catalogLinks: any[];

  constructor(

    public authService: MsalService,
    private http: HttpClient,
    private modalService: BsModalService,
    public router: Router,
    public sanitizer: DomSanitizer
  ) {
    console.log("DataService Init!");
    this.am = new AuthManager(this);
    //this.am.startUp(this);

    /*
    this.router.events.filter(event => event instanceof NavigationStart).subscribe((event: NavigationStart) => {
      this.currentRoute = event.url;
      this.log("NavigationStart: " + this.circularStringify(event));
    });
*/
    this.router.events.pipe(
      filter((e) => e instanceof NavigationStart && e.navigationTrigger === 'imperative'),
      switchMap(() => this.router.events.pipe(
        filter(e => e instanceof NavigationEnd
          || e instanceof NavigationCancel
          || e instanceof NavigationError
        ),
        take(1),
        filter(e => e instanceof NavigationEnd)
      ))
    ).subscribe(val => {
      console.log("Navigation event: " + typeof (val), val);
    });

    this.catalogLinks = [
      { href: 'http://ascbp.com/files/CC150_CladdingColorChart.pdf', html: 'Color Palette' },
      { href: 'http://ascbp.com/files/productsheet/PS178_PBR_Marketing%20Product%20Sheet.pdf', html: 'PBR Panel' },
      { href: 'http://ascbp.com/files/productsheet/BR136_TriLapBrochure.pdf', html: 'TriLap&copy;' },
      { href: 'http://ascbp.com/files/productsheet/PS226_Klondike.pdf', html: 'Klondike&copy;' },
      { href: 'http://ascbp.com/files/productsheet/PS160_IronOx.pdf', html: 'IronOx&trade;' },
      { href: 'http://ascbp.com/files/productsheet/PS215_Country%20Rustic.pdf', html: 'Country Rustic Corrugated&copy;' },
      { href: 'http://ascbp.com/files/productsheet/PS_Skyline%20Roofing%20hp.pdf', html: 'Skyline Roofing&copy; hp' },
      { href: 'http://ascbp.com/files/productsheet/Corrugated.pdf', html: '2 1/2 Corrugated' },
      { href: 'http://ascbp.com/files/productsheet/PS131_Skyline.pdf', html: 'Skyline Roofing&copy;' },
      { href: 'http://ascbp.com/files/productsheet/PS223_Delta%20Rib.pdf', html: 'Delta Rib&trade;' },
      { href: 'http://ascbp.com/files/productsheet/PS222_Delta%20Rib%20III.pdf', html: 'Delta Rib&trade; III' },
      { href: 'http://ascbp.com/files/productsheet/PS220_Nor-Clad.pdf', html: 'Nor-Clad&copy;' },
      { href: 'http://ascbp.com/files/productsheet/PS221_Strata%20Rib.pdf', html: 'Strata Rib&copy;' },
    ];

  }


  initData() {
    this.triggerVersionCheck().then(result => console.log('Version check result: ' + result));

    //let modelNotCached = true;

    let modelNotCached = localStorage.getItem("model") === null;

    /*
    if (window.location.hostname.indexOf("localhost") > -1
      || window.location.hostname.indexOf("steel.bhpsteel.net") > -1
      || window.location.hostname.indexOf("portalsbx") > -1
      || window.location.hostname.indexOf("portalqas") > -1) {
      this.debugAjax = true;
    }
      */

    if (modelNotCached) {
      this.router.navigate(['home']);
      // this.get(`/Init?t=${Date.now()}`, null).subscribe(data => {
      this.get("/Init", null).subscribe(data => {
        console.dir(data);



        data.customerSet.forEach((soldTo) => {
          soldTo.keyWords = [soldTo.Soldto, soldTo.SearchTerm, soldTo.Name, soldTo.City, soldTo.State].join(" ").toLowerCase();
          //soldTo.found = true;
          soldTo.selected = false;
        });
        data.customerSetFiltered = this.deref(data.customerSet);
        data.categorySet = this.chunk(data.categorySet, 2);


        //if only customer, autoselect :
        if (data.customerSet.length == 1) {
          this.model.SoldTo = data.customerSet[0];
          console.log("Set model.SoldTo to ", data.customerSet[0]);
          this.get("/ShipToList?soldTo=" + this.model.SoldTo.Soldto, null).subscribe((result) => {
            this.model.shipToList = result;
          });
          this.get("/GetJobSiteDelivery?soldTo=" + this.model.SoldTo.Soldto, null).subscribe((result) => {
            this.model.jobSiteDelivery = result
          });




        }
        //this is initially empty, so why are we messing with this now?
        /*
        data.panels.forEach((p) => {
          p.MinCutlistLength = parseInt(p.MinCutlistLength, 10);
          p.MaxCutlistLength = parseInt(p.MaxCutlistLength, 10);
        });
        */

        // data reprocessing completed, so let's set the model:
        Object.keys(data).forEach((key) => {
          this.model[key] = data[key];
        });


        if (!this.model.flags.hasOwnProperty("alaska_closure")) {
          // they are using a cached init model
          localStorage.removeItem("model"); // force model expiration
          this.model.flags["alaska_closure"] = false;
        }

        if (this.model.flags.alaska_closure && this.model.SoldTo.State == "AK") {
          this.model.packagingTypeSet.forEach(p => {
            console.log("XP PACK - data.service 309");
            p.PackDisabled = p.PackType != "XP";
          })
        }


        if (this.model.hasOwnProperty('html')) {
          if (this.model.html.hasOwnProperty('announcements')) {
            this.model.html.announcements = this.model.html.announcements.replace('{{contact.firstname}}', this.model.accountInfo.FirstName);
            this.model.html.announcements = this.model.html.announcements.replace('{{contact.lastname}}', this.model.accountInfo.LastName);
            this.model.html.announcements = this.model.html.announcements.replace('{{contact.email}}', this.model.accountInfo.UserName);
          }
        }

        this.debugVisible = this.model.flags.dev_mode;
        this.model.cart = this.initCart();

        console.log("Set model ready!");
        this.modelReady = true;
        this.checkAgreement();
      });
    } else {
      console.log("Model cached, restoring init package from localStorage...");
      let data = JSON.parse(localStorage.getItem("model"));
      Object.keys(data).forEach((key) => {
        this.model[key] = data[key];
      });
      console.log("Set model ready!");
      this.modelReady = true;
    }

    if (this.model.accountInfo === undefined) {
      alert('User not recognized, logging off');
      this.post('/Account/LogOff', {}, {}).subscribe(result => {
        console.dir(result);
        location.href = "/";
      });
    }
  }

  processError(error) {
    console.log('processError', error);
    if (this.errorReportInProgress) {
      console.log("CANNOT REPORT SIMULTANEOUS ERRORS!");
      return; //prevent severe errors from looping 
    } else {

    }
    this.errorReportInProgress = true;


    let props = this.objProps(error);
    console.log('Error props', props);
    this.errorMsg = {};
    this.errorMsg.errorUserDescription = "";
    this.errorMsg.route = window.location.href;
    this.errorMsg.userAgent = window.navigator.userAgent;
    props.forEach((prop) => {
      this.errorMsg[prop] = error[prop];
    });

    if (this.errorMsg.hasOwnProperty("status")) {
      if (this.errorMsg.status == 403 || this.errorMsg.status == "403") {
        alert("Your session has expired. Please log in again.");
        //this.am.logout();
        this.am.clearUser();
        return;
      }
    }

    console.log("d.errorMsg", this.errorMsg);

    if (error.message.indexOf('/Endpoint/ReportUIError') > -1) {
      console.log("Can't report error!");
      return;
    }





    //this.submitError();

    this.updateLoader(0);
    this.appRef.errorModalRef = this.showModal(this.appRef.errorModal, "modal-lg modal-dialog-centered errorModal");
    this.focusInput("errorText");


  }


  readFileAsDataUrlAsync(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();

      reader.onloadend = () => {
        resolve(reader.result);
      };

      reader.onerror = reject;

      reader.readAsDataURL(file);
    })
  }

  async triggerVersionCheck() {
    await new Promise(resolve => this.checkVersion());
    return true;
  }

  async checkVersion() {
    try {
      const responseVerson = await fetch(`/assets/latestVersion.json?t=${Date.now()}`);
      const latest = await responseVerson.json();
      //console.log('current version:', this.version);
      //console.log('Version check result: ', latest);

      if (latest.version == this.version) {
        console.log('Version check passed: ' + latest.version);
      } else {
        console.log(this.version + ' -> ' + latest.version);
        console.log('Version check failed, reloading...');

        this.updatingVersion = true;

        setTimeout(() => {
          // const refreshUrl = `${window.location.protocol}//${window.location.host}?t=${Date.now()}`;
          // console.log(refreshUrl);
          // window.location.href = refreshUrl;
          this.reload();

        }, 1500);

        return;
      }

    } catch (e) {
      console.error('Could not verify version', e);
    }
  }

  reload() {
    // const curHref = window.location.href.split('?');
    // window.location.href = curHref[0];
    window.location.reload();
  }

  async checkAgreement() {

    if (!this.model.accountInfo.HasAgreedToTerms) {
      await this.delay(150);
      this.appRef.agreementModalRef = this.showModal(this.appRef.agreementModal, "modal-xl modal-dialog-centered modal-dialog-scrollable", true);
    }

  }

  agreeToTerms(didAgree: boolean) {
    if (didAgree) {

      this.get("/AgreeToTerms?ClickedAgree=" + didAgree, {}).subscribe((result) => {
        this.appRef.agreementModalRef.hide();
      });
    } else {
      //clear cart for onbeforeunload, which doesn't work right if the cart hasn't been created yet
      if (!this.model.hasOwnProperty('cart')) this.model.cart = { OrderItemSet: [] };
      if (!this.model.cart.hasOwnProperty('OrderItemSet')) this.model.cart = { OrderItemSet: [] };
      this.model.cart.OrderItemSet = [];
      this.am.logout();
    }
  }

  initJobsite() {
    return {
      AcceptedTerms: false,
      RequestedShipDate: null,
      DeliveryInformation: {
        Address: {
          Street: "",
          City: "",
          State: "",
          Zip: ""
        },
        BackupAddress: {
          Street: "",
          City: "",
          State: "",
          Zip: ""
        },
        ContractorCompanyName: "",
        ContractorContact: "",
        ContractorPhone: "",
        JobsitePhone: "",
        YourPhone: "",
        AdvancedDeliveryNoticeRequired: false,
        NumberOfHoursNoticeRequired: "1-2"
      },
      UnloadingMethod: {
        html: "Select Unloading Method...",
        text: "Select Unloading Method..."
      },
      TwoForkliftsRequired: false,
      TruckEntryToJobsite: {
        html: "Select Truck Entry Method...",
        text: "Select Truck Entry Method..."
      },
      DrivingDirections: "",
      mapUrl: "",
      backupMapUrl: "",
      LocationZone: "",
      AcceptedByUser: "",
      AcceptedTime: "",
      errors: []
    }
  }


  deref(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  chunk(input, size) {
    return input.reduce((arr, item, idx) => {
      return idx % size === 0
        ? [...arr, [item]]
        : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]];
    }, []);
  };

  has(obj, key) {
    var keyParts = key.split('.');

    return !!obj && (
      keyParts.length > 1
        ? this.has(obj[key.split('.')[0]], keyParts.slice(1).join('.'))
        : this.hasOwnProperty.call(obj, key)
    );
  };

  trimLeadingZeros(strnum) {
    if (!strnum) return strnum;
    strnum = strnum.replace(/^[0]+/g, "");
    return strnum.length == 0 ? "0" : strnum;
  }

  sapToJsDate(sapDateString: string): Date {
    let y = sapDateString.substr(0, 4);
    let m = sapDateString.substr(4, 2);
    let d = sapDateString.substr(6, 2);
    //console.log(y+"-"+m+"-"+d);
    let nY = Number(y);
    let nM = Number(m);
    let nD = Number(d);
    //console.log(nY+"-"+nM+"-"+nD);
    let jsDate = new Date(nY, nM - 1, nD); //new Date(year, month, day,
    //console.log(jsDate);
    return jsDate;
  }

  jsToSapDate(d: Date): string {
    return [
      d.getFullYear(),
      this.pad(d.getMonth() + 1, 2, '0'),
      this.pad(d.getDate(), 2, '0')
    ].join("");
  }

  pad(n: Number, width: number, z?: string): string {
    z = z || '0';
    let nS = n + '';
    return nS.length >= width ? nS : new Array(width - nS.length + 1).join(z) + nS;
  }

  //modalRef?: BsModalRef;
  modalRefs: Array<Popup> = [];
  showModal(template: TemplateRef<any>, classNames: string = 'modal-lg modal-dialog-centered', noEscape = false) {
    var modalParams: ModalOptions = {
      class: classNames,
      keyboard: true,
      focus: true
    };
    if (noEscape) {
      modalParams.keyboard = false;
      modalParams.backdrop = 'static';
    }
    return this.modalService.show(template, modalParams)
  }

  searchSoldTo(searchTerms) {

    let aSearchTerms = searchTerms != null ? searchTerms.toLowerCase().split(" ") : [];
    let minScore = aSearchTerms.length;
    if (searchTerms !== null && searchTerms.length > 0) localStorage.setItem('soldToSearch', searchTerms);
    this.model.customerSetFiltered = this.model.customerSet.filter((soldTo) => {
      if (minScore == 0) return true;
      let score = 0;
      aSearchTerms.forEach((searchTerm) => {
        if (soldTo.keyWords.indexOf(searchTerm) > -1) score += 1;
      });
      return (score >= minScore);
    });
  }

  cloneDeep(obj) {
    return cloneDeep(obj);
  }

  postForm(url: string, params: any, formData: FormData, inBackground: boolean = false): Observable<any> {

    const headers = new HttpHeaders({
      //'Content-Type': 'application/json; charset=utf-8', //Disabling this seems counterintuitive, but it's required!
      'accept': 'application/json; charset=utf-8',
    });
    const requestOptions = { headers: headers };
    var absoluteUrl = this.API_ROOT + '/Endpoint' + url;
    //console.info("POST> " + absoluteUrl);

    let request = this.http.post(absoluteUrl, formData, requestOptions);
    request = request.pipe(share());//allows multiple subscribers without doubling the http request 

    if (!inBackground) this.updateLoader(1);
    request.subscribe({
      next: (result) => {
        if (this.debugAjax) console.info("POST: " + absoluteUrl + "\n  REQUEST:", formData, "\n RESPONSE:", result);
      },
      error: (error) => {
        if (!inBackground) this.updateLoader(-1);

        if (this.debugAjax) console.info("POST: " + absoluteUrl + "\n  REQUEST:", formData, "\n RESPONSE: error");
        console.error(error);
        if (error.status == 403) {
          this.post('/Account/LogOff', {}, {}).subscribe(result => {
            console.dir(result);
            location.href = "/";
          });
        } else {

          //window['serverError'] = error;
          error.requestHeaders = headers;
          //this.errorMsg = error;
          //this.displayError(error);
          throw (error);


        }
      },
      complete: () => {
        if (!inBackground) this.updateLoader(-1);
        console.info('complete');
      }
    });

    return request;
  }

  /** @description Asycn wrapper for post. Performs a POST against the back end api
   * @param {string} url The full url of the api endpoint.
   * @param {any} params The object that will be turned into the URL Parameters
   * @param {any} data The object that will be stringified and become the post body
   * @return {Observable}
   */
  async inlinePost(url: string, params: any, data: any, modal: boolean = true) {
    return new Promise<any>((resolve, reject) => {
      this.post(url, params, data, modal).subscribe((result) => {
        resolve(result);
      })
    });
  }

  post(url: string, params: any, data: any, modal: boolean = false): Observable<any> {

    let body = JSON.stringify(data);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'accept': 'application/json; charset=utf-8',
    });
    const requestOptions = { headers: headers };
    var absoluteUrl = this.API_ROOT + '/Endpoint' + url;
    //console.info("Starting POST: " + absoluteUrl);

    let request = this.http.post(absoluteUrl, body, requestOptions);
    request = request.pipe(share());//allows multiple subscribers without doubling the http request 
    modal = false;
    if (!modal) this.updateLoader(1);
    request.subscribe({
      next: (result) => {
        if (this.debugAjax) console.info("POST: " + absoluteUrl + "\n  REQUEST:", data, "\n RESPONSE:", result);
      },
      error: (error) => {
        if (!modal) this.updateLoader(-1);

        if (this.debugAjax) console.info("POST: " + absoluteUrl + "\n  REQUEST:", data, "\n RESPONSE: error");
        console.error(error);
        if (error.status == 403) {
          this.post('/Account/LogOff', {}, {}).subscribe(result => {
            console.dir(result);
            location.href = "/";
          });
        } else {

          //window['serverError'] = error;
          error.requestHeaders = headers;
          //his.displayError(error);
          throw (error);


        }
      },
      complete: () => {
        if (!modal) this.updateLoader(-1);
        console.info('complete');
      }
    });

    return request;
  }
  get(url: string, params: any, modal: boolean = true): Observable<any> {
    //modal = false;
    if (!modal) this.updateLoader(1);
    //let options = new HttpRequest RequestOptions();
    var absoluteUrl = this.API_ROOT + '/Endpoint' + url;
    let request = this.http.get(absoluteUrl); //, options);
    request = request.pipe(share());
    //console.info("GET> " + absoluteUrl);
    request.subscribe(result => {
      if (!modal) this.updateLoader(-1);
      //console.log("GET< " + absoluteUrl, result);
      if (this.debugAjax) console.info("GET: " + absoluteUrl + "\n RESPONSE:", result);

    }, (error) => {
      console.log("GET ERROR:", error)
      if (error.status == 401) {
        this.am.logout();
      }
      this.processError(error);
    });

    return request;
  }

  /** @description Async wrapper for get. Performs a GET against the back end api
   * @param {string} url The full url of the api endpoint.
   * @param {any} params A js object that will be turned into the URL Parameters
   * @return {any}
   */
  async inlineGet(url: string, params: any = {}, modal: boolean = true) {

    return new Promise<any>((resolve, reject) => {
      this.get(url, params, modal).subscribe((result) => {
        resolve(result);
      })
    });
  }

  async inlineDownload(url: string, params: any = {}) {

    return new Promise<any>((resolve, reject) => {
      this.download(url).subscribe((result) => {
        console.log("inlineDownload got this: ", result);
        resolve(result);
      })
    });
  }

  /** @description Performs an simpld download of any raw data
   * @param {string} url The full url of the api endpoint.
   * @param {any} params A js object that will be turned into the URL Parameters
   * @return {Observable}
  
  download(url: string, params: any): Observable<any> {
    var absoluteUrl = this.API_ROOT + '/Endpoint' + url;
    let request = this.http.get(absoluteUrl); //, options);
    request = request.pipe(share());
    request.subscribe((result) => {
      //console.log("GET DOWNLOAD returned: " + url);
    });
 
    return request;
  } */
  download(url: string): Observable<Blob> {
    var prefix = this.API_ROOT + '/Endpoint';
    var absoluteUrl = url.startsWith(prefix) ? url : prefix + url;

    return this.http.get(absoluteUrl, {
      responseType: 'blob'
    })
  }


  convertToCSV(data: any[], headers?: string[]): string {
    if (!Array.isArray(data) || data.length === 0) return '';

    var dataHeaders: CsvHeader[] = [];

    // Extract headers from the first object in the array or use provided headers with modifications
    headers.forEach(h => {
      let [srcCol, dispCol] = h.split('>');
      dataHeaders.push({
        srcColumn: srcCol,
        displayName: dispCol == null ? srcCol : dispCol
      });
    });


    let csvContent = dataHeaders.map(dh => dh.displayName) + '\r\n';
    data.forEach(d => {
      let row: any[] = [];
      dataHeaders.forEach(dh => {

        var cellData = d[dh.srcColumn];
        if ((typeof cellData === 'string' && (cellData.includes(',') || cellData.includes('"') || cellData.includes('\n')))) {
          row.push(`"${cellData.replace(/"/g, '""')}"`);
        } else {
          row.push(cellData);
        }

      });
      csvContent += row.join(',') + '\r\n';
    });
    return csvContent;
  }


  downloadCSV(data: any[], prefix: string, headers?: string[]) {
    const blob = new Blob([this.convertToCSV(data, headers)], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const currentDateTime = new Date().toISOString().replace(/[:.]/g, '-'); // Replace : and . with - to avoid issues in filenames

    const anchorElement = document.createElement('a');
    anchorElement.href = url;
    anchorElement.download = `${prefix}-${currentDateTime}.csv`;
    anchorElement.click();
    URL.revokeObjectURL(url);
  }


  updateLoader(increment: number) {
    if (increment == 0) {
      this.ajaxCount = 0; //something bad happened, this is a reset.
    } else {
      this.ajaxCount += increment;
      if (this.ajaxCount < 0) this.ajaxCount = 0;
    }
    if (this.appRef.hasOwnProperty('changeDetectorRef')) {
      this.appRef.changeDetectorRef.detectChanges(); //Angular is silly.
    }

    /*
    var loadingMask = document.getElementById("loadingMask");
    if (this.ajaxCount > 0) {
      loadingMask?.classList.add("active");
 
    } else {
      loadingMask?.classList.remove("active");
 
    }
*/


  }

  checkPreReqsAndRoute(preReqs: Array<string>, route: string) {
    console.log("checkPreReqsAndRoute:", preReqs, route)


    //var arrayLength = preReqs.length;
    for (var i = 0; i < preReqs.length; i++) {
      var preReq = preReqs[i];

      if (preReq == "SoldTo") {

        // If they select a disabled Sold To, only allow them to view past orders:
        if (this.model.SoldTo.hasOwnProperty('Soldto')) {
          console.log("We do have a SoldTo, here it is:");
          console.log(this.model.SoldTo);
          const nameMask = this.model.SoldTo.Name.toLowerCase().substring(0, 3);
          if (nameMask == "xxx" || nameMask == 'zzz') {
            if (route.indexOf('/orders') != 0) {
              this.toast("Ordering disabled for: " + this.model.SoldTo.Name)
              this.model.ShipTo = {};
              this.model.SoldTo = {};
              this.lastAction = () => { this.checkPreReqsAndRoute(preReqs, route); }
            }
          }
        }

        if (!this.model.SoldTo.hasOwnProperty('Soldto') || this.model.SoldTo.Soldto === undefined) {
          console.log("SoldTo requirement NOT met!");
          this.lastAction = () => { this.checkPreReqsAndRoute(preReqs, route); }
          this.appRef.changeSoldto();
          return;
        } else {
          console.log("SoldTo requirement met!");
          if (this.model.honorJSDREnabled) {
            console.log("Honoring the JSDREnabled, setting enable_jobsite flag to: " + this.model.SoldTo.JSDREnabled);
            this.model.flags.enable_jobsite = this.model.SoldTo.JSDREnabled
          } else {
            console.log("Not honoring the JSDREnabled flag, because no SoldTos are JSDREnabled");
          }
        }
      }

      if (preReq == "ShipTo") {
        if (!this.model.ShipMode.hasOwnProperty('Name') || this.model.ShipMode.Name === undefined) {
          console.log("ShipTo requirement NOT met!");
          this.lastAction = () => { this.checkPreReqsAndRoute(preReqs, route); }

          if (this.model.flags.enable_jobsite) {
            //this will fail if model.jobSiteDelivery is null
            this.openJobsitePrompt();
          } else {
            this.appRef.changeShipto();
          }

          return;
        } else {
          console.log("ShipTo requirement met!");
        }
      }

    }

    //if we get this far, all prerequisites have been met, so it's okay to route:
    //console.log("All requirements met, routing to " + route);
    //this.controllers.app.router.navigate([route]);
    this.router.navigate([route]);
  }
  openJobsitePrompt() {
    alert("openJobsitePrompt not implemented")
  }
  closeJobsitePrompt(decision) {

    alert("closeJobsitePrompt not implemented");
    /*
        $('#jobsitePrompt').modal('hide');
        setTimeout(() => {
          this.showJobsitePrompt = false;
 
          if (decision == 'jobsite') this.openJobsiteModal();
          if (decision == 'normal') this.controllers.app.changeShipto();
 
        }, 100);
    */

  }



  objProps(obj) {
    var props = Object.getOwnPropertyNames(obj);
    for (var prop in obj) {
      if (!obj.hasOwnProperty(prop)) {
        props.push(prop);
      }
    }

    var invalidProps = ["originalError", "context", "constructor", "toString", "longStack", "_nativeError"];
    var result = [];
    props.forEach((prop) => {
      if (invalidProps.includes(prop)) return;
      result.push(prop);
    });


    return result;
  }

  public async submitError() {

    console.log("submitError: ", this.errorMsg);

    var errorPayload = this.circularStringify(this.errorMsg);
    if (!this.errorMsg.hasOwnProperty("_body")) {
      console.log("this is a JS error, so report the error properties as JSON");
      this.errorMsg._body = '<span class="errorJson">' + errorPayload + '</span>';
    } else {
      console.log("this is a server error, so report the HTML that the server returned");
      this.errorMsg._body = this.errorMsg._body.replace('<style>', '<!--<style>').replace('</style>', '</style>-->')  //this.stripStyleHtml(this.errorMsg._body);
      errorPayload = JSON.stringify(this.errorMsg, null, 4);
    }



    let formData = new FormData();

    formData.append('error', new Blob([errorPayload]));
    formData.append('model', new Blob([JSON.stringify(this.model, null, 2)]));
    formData.append('runlog', new Blob([this.runLog.join('\r\n')]));

    await this.getScreenshot();
    if (this.screenshotBlob != null) formData.append('screenshot', this.screenshotBlob);

    this.postForm("/ReportUIError", {}, formData, true).subscribe(result => {
      let data = result;
      console.dir(data);
      console.log("Error report succeeded!");
      setTimeout(() => {
        this.errorReportInProgress = false;
      }, 100);

    });



  }

  async getScreenshot() {
    console.log("Attemping screenshot...");
    this.screenshotBlob = null;
    return new Promise((resolve, reject) => {
      try {
        //window['html2canvas'](document.body, { useCORS: true }).then((canvas) => {
        html2Canvas(document.body, { useCORS: true }).then((canvas) => {
          //console.log('%c   ', 'font-size:270px;display:inline-block;width: 480px;height:270px;background:url(' + canvas.toDataURL() + ') no-repeat;     background-origin: padding-box;background-position-x: 50%;background-position-y: 50%;background-repeat: no-repeat;background-size: cover;');
          canvas.toBlob((blob) => {
            this.screenshotBlob = blob;
            console.log("Screenshot succeeded!");
            resolve("Screenshot succeeded!");
          });
        }).catch((err) => {
          console.log("Screenshot failed:");
          resolve("Screenshot failed:");
          console.dir(err);
        });

      } catch (e) {
        console.log("Screenshot crashed:");
        resolve("Screenshot crashed:");
        console.dir(e);
      }
    });

  }

  clearStorage() {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(";").forEach((c) => { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
  }


  closeErrorDialog() {
    if (this.errorMsg.errorUserDescription.length > 0) {

      console.log("User Error Report:");
      console.dir(this.errorMsg.errorUserDescription);
      //var errorComment = JSON.stringify({ errorComment: this.errorMsg.errorUserDescription }, null, 2);
      var errorPayload = this.circularStringify(this.errorMsg);
      //console.log(errorComment);

      let formData = new FormData();
      formData.append('error', new Blob([errorPayload]));
      this.postForm("/ReportUIError", {}, formData, false).subscribe(result => {
        let data = result;
        console.dir(data);
      });

    }
    setTimeout(() => {
      this.appRef.errorModalRef.hide();
      delete this.errorMsg._body;
    }, 100);

  }

  focusInput(elementId: string, selectAll = false) {
    setTimeout(() => {
      var inputValue = (<HTMLInputElement>document.getElementById(elementId));
      if (inputValue != null) {
        inputValue.focus();
        if (selectAll) inputValue.select();
      } else {
        console.error("Couldn't focus on element with ID: " + elementId);
      }
    }, 250);

  }
  selectInput(elementId: string) {
    setTimeout(() => {
      var inputValue = (<HTMLInputElement>document.getElementById(elementId));
      if (inputValue != null) {
        inputValue.select();
      } else {
        console.error("Couldn't select input with ID: " + elementId);
      }
    }, 250);
  }
  selectFocus(elementId: string) {
    setTimeout(() => {
      var inputValue = (<HTMLSelectElement>document.getElementById(elementId));
      if (inputValue != null) {
        inputValue.focus();
      } else {
        console.error("Couldn't focus on select with ID: " + elementId);
      }
    }, 250);
  }
  clearInput(elementId: string) {
    setTimeout(() => {
      var inputValue = (<HTMLInputElement>document.getElementById(elementId));
      if (inputValue != null) {
        inputValue.value = "";
      } else {
        console.error("Couldn't clear input with ID: " + elementId);
      }
    }, 250);
  }
  clickElement(elementId: string) {
    setTimeout(() => {
      var el = (<HTMLElement>document.getElementById(elementId));
      if (el != null) {
        el.click();
      } else {
        console.error("Couldn't click element with ID: " + elementId);
      }
    }, 250);
  }


  async addToCartAnim() {
    document.getElementById('cartBtn')?.classList.add('waggle');

    //let  cartBtn = document.getElementById('cartBtn');
    //this.addClass(cartBtn, "waggle");
    setTimeout(() => {
      //this.removeClass(cartBtn, "waggle");
      document.getElementById('cartBtn')?.classList.remove('waggle');
    }, 250);
  }

  addClassById(id: string, className) {
    document.getElementById(id)?.classList.add(className);
  }

  removeClassById(id: string, className) {
    setTimeout(() => {
      document.getElementById(id)?.classList.remove(className);
    }, 100); //give the click handler a chance to fire

  }

  isNil(value) {
    return value == null;
  }
  isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length;

  colordesc(colorId) {
    if (!colorId) return colorId;
    let match: any = this.model.colorSet.find(c => c.ColorId == colorId);
    return match.ColorDescription;
  }
  colordescM = memoize(this.colordesc);

  openInNewTab(href) {
    Object.assign(document.createElement('a'), {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: href,
    }).click();
  }

  addClass(e, className) {
    let srcElement: HTMLElement = (e.srcElement || e.target);
    srcElement?.classList.add(className);
  }

  removeClass(e, className) {
    let srcElement: HTMLElement = (e.srcElement || e.target);
    setTimeout(() => {
      srcElement?.classList.remove(className);
    }, 100); //give the click handler a chance to fire

  }
  stripNonAlphaNumeric(input) {
    return input.replace(/[^0-9a-z]/gi, '');
  }

  filetypeIcon(filename: string) {
    let ext = filename.indexOf(".") > -1 ? filename.split('.')[1].toLowerCase() : "";
    switch (ext) {

      case "txt":
        return this.faFileAlt;

      case "pdf":
        return this.faFilePdf;

      case "doc": case "docx":
        return this.faFileWord;

      case "jpg": case "jpeg": case "png":
        return this.faFileImage;

      default: return this.faFileImage;
    }
  }


  async initFctData() {
    console.log("initFctData!");
    if (!this.model.hasOwnProperty('TrimFullyCustomSet')) {
      console.log("initFctData downloading...");
      var ShippingPlant = this.model.ShipTo.SHIPPINGPLANT;
      var ShippingModeId = this.model.ShipMode.ShippingModeId;
      var fctData = await this.inlineGet(`/GetFCTSet?ShippingPlant=${ShippingPlant}&ShippingModeId=${ShippingModeId}`, {});


      Object.keys(fctData).forEach((key) => {
        this.model[key] = fctData[key];
      });

      //console.dir(ctrl.dataSvc.model.TrimFullyCustomSet);
    } else {
      //let trimInfo = _.find(ctrl.dataSvc.model.TrimFullyCustomSet,{PictureId:'RIDCV'});
      //this.editTrim(trimInfo);
    }
    console.log("initFctData: ", this.model.TrimFullyCustomSet);
  }

  async initXyData() {

    if (!this.model.hasOwnProperty('TrimXYGroupSet')) {
      var xyData = await this.inlineGet('/GetTrimXYGroupSet', {});
      xyData.forEach((item) => {
        //item.ImageUrl = dataSvc.model.imageProxyUrl + "?contenttype=trim&id=" + item.PictureId + "_P";
        item.ImageUrl = "/images/Trim/" + item.PictureId + "_P.svg";
        item.hasTdl = item.TDLData.length > 0;

        if (item.hasTdl) {
          try {
            var parsed = JSON.parse(item.TDLData);
            item.TDLData = parsed;
            //item.TDLData.canSelectPaintedSide = (item.TDLData.paintedSide == "");

            //if (item.TDLData.canSelectPaintedSide) item.TDLData.paintedSide = "L"

            //console.log(item.PictureId);
            //if (item.PictureId == 'RIDCV') this.editTrim(item);

          } catch (e) {
            console.warn(`Failed to parse TDLData, invalid JSON in ${item.PictureId}!`);
            console.dir(item.TDLData);
            item.TDLData = {};
          }
        }

      });

      this.model.TrimXYGroupSet = xyData;
      //console.dir(ctrl.dataSvc.model.TrimXYGroupSet);
    } else {
      //let trimInfo = _.find(ctrl.dataSvc.model.TrimXYGroupSet,{PictureId:'RIDCV'});
      //this.editTrim(trimInfo);
    }
  }

  noAction(e: any) {
    //cancels any click event
    //console.dir(e);
    if (e.srcElement.id == 'uploadBtn') return;
    //console.log("dataSvc noaction!");
    e.returnValue = false;
    e.cancelBubble = true;
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (e.stopPropagation) e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
    return false;
  }
  //used by both trims and order history:
  async retreiveTrimMetadata(selectedTrim) {


    var TrimXYGroupId = selectedTrim.metadata.TrimXYGroupId;
    var ShippingPlant = this.model.ShipTo.SHIPPINGPLANT;
    var ShippingModeId = this.model.ShipMode.ShippingModeId;
    selectedTrim.metadata.TrimXYSet = await this.inlineGet('/GetTrimXYSet?TrimXYGroupId=' + TrimXYGroupId + '&ShippingPlant=' + ShippingPlant + '&ShippingModeId=' + ShippingModeId, {});
    selectedTrim.metadata.TrimXYGroupData = await this.inlineGet('/GetTrimXYGroupData?TRIMXYGROUPID=' + TrimXYGroupId, {});
    selectedTrim.metadata.TrimXYGroupFilterGauge = await this.inlineGet('/GetTrimXYGroupFilterGauge?TRIMXYGROUPID=' + TrimXYGroupId, {});
    selectedTrim.metadata.TrimXYGroupFilterGauge.forEach((item) => {
      item.selected = false;
    });

    //why are are these strings in the first place?
    selectedTrim.metadata.TrimXYSet.forEach((xy) => {
      //console.log(xy);
      xy.HasPOPCapability.AngleMin = Number(xy.HasPOPCapability.AngleMin);
      xy.HasPOPCapability.HemLength = Number(xy.HasPOPCapability.HemLength);
      xy.HasPOPCapability.GirthMin = Number(xy.HasPOPCapability.GirthMin);
      xy.HasPOPCapability.HemConfiguration.results.forEach((hc) => {
        hc.HemLength = Number(hc.HemLength);
        hc.GirthMin = Number(hc.GirthMin);
      });
    });

    selectedTrim.metadata.TrimXYGroupData.results.forEach((gd) => {
      //append colorset information

      let color: any = this.model.colorSet.find(c => c.ColorId == gd.ColorCode);
      if (!color) {
        //console.log("Can't find " + gd.ColorCode + " in colorSet:");
        //console.dir(dataSvc.model.colorSet);
        gd.BasecolorId = gd.ColorCode;
        gd.ColorDescription = gd.ColorCode;
        gd.ColorId = gd.ColorCode;
        gd.RGB = "#FF00FF";
      } else {
        gd.BasecolorId = color.BasecolorId;
        gd.ColorDescription = color.ColorDescription;
        gd.ColorId = color.ColorId;
        gd.RGB = color.RGB;
      }
    });

    //console.log(customTrim);
    //console.dir(selectedTrim.metadata.TDLData);
    let hemCount = selectedTrim.metadata.TDLData.flanges.filter((f) => { return this.isHem(f); }).length;
    selectedTrim.metadata.hemConfig = selectedTrim.metadata.TrimXYSet[0].HasPOPCapability.HemConfiguration.results.find(h => h.Hems == hemCount);

    //set start hem length  
    if (this.isHem(selectedTrim.metadata.TDLData.flanges[0])) {
      selectedTrim.metadata.TDLData.flanges[0].value = selectedTrim.metadata.hemConfig.HemLength;
    }
    //set end hem length
    if (this.isHem(selectedTrim.metadata.TDLData.flanges[selectedTrim.metadata.TDLData.flanges.length - 1])) {
      selectedTrim.metadata.TDLData.flanges[selectedTrim.metadata.TDLData.flanges.length - 1].value = selectedTrim.metadata.hemConfig.HemLength;
    }
    /*
    //set start hem length
    if (selectedTrim.metadata.TDLData.flanges[0].length == 0 && Math.abs(selectedTrim.metadata.TDLData.flanges[0].angle) == 180) {
      selectedTrim.metadata.TDLData.flanges[0].length = selectedTrim.metadata.hemConfig.HemLength;
    }
    //set end hem length
    if (selectedTrim.metadata.TDLData.flanges[selectedTrim.metadata.TDLData.flanges.length - 1].length == 0) {
      if (Math.abs(selectedTrim.metadata.TDLData.flanges[selectedTrim.metadata.TDLData.flanges.length - 2].angle) == 180) {
        selectedTrim.metadata.TDLData.flanges[selectedTrim.metadata.TDLData.flanges.length - 1].length = selectedTrim.metadata.hemConfig.HemLength;
      }
    }
    */
    return selectedTrim;
  }

  isHem(flangeNode) {
    if (typeof flangeNode == 'undefined') {
      console.log("Can't run isHem on undefined!");
      return false;
    }
    let hemTypes = ['posHem', 'negHem', 'posHook', 'negHook'];

    return hemTypes.includes(flangeNode.type)
  }

  formatFraction(input) {
    var gcd = function (a, b) {
      if (!b) return a;
      a = parseInt(a);
      b = parseInt(b);
      return gcd(b, a % b);
    };

    var aInput = (input + "").split(".");

    if (aInput.length == 1) return aInput[0];

    var fraction = Number("0." + aInput[1]);


    var len = fraction.toString().length - 2;

    var denominator = Math.pow(10, len);
    var numerator = fraction * denominator;

    var divisor = gcd(numerator, denominator);    // Should be 8

    numerator /= divisor;                         // Should be 439
    denominator /= divisor;                       // Should be 1250

    var fractionText = numerator.toFixed() + '/' + denominator.toFixed();
    return aInput[0] == "0" ? fractionText : aInput[0] + " " + fractionText;
  }

  getMetalName(metalId) {
    if (!metalId) return metalId;
    let match: any = this.model.metalSet.find(m => { return m.MetalId == metalId });
    return match.MetalDescription;
  }
  sortBy(key) {
    return (a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0);
  };



  isObject(a) {
    return typeof a === "object";
  }

  wait(checkFunction: any, callback: any, ms: number) {

    if (typeof checkFunction !== "function") throw "Could not wait, first param must be a function";
    if (typeof callback !== "function") throw "Could not wait, second param must be a function";
    if (checkFunction()) {
      callback();
    } else {
      setTimeout(() => {
        this.wait(checkFunction, callback, ms);
      }, ms);
    }
  }

  intersection(arr1, arr2) {
    return [arr1, arr2].reduce((a, b) => a.filter(c => b.includes(c)))
  }

  pull(arr, ...removeList) {
    var removeSet = new Set(removeList)
    return arr.filter((el) => {
      return !removeSet.has(el)
    })
  }

  validEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  productDisabled(catId) {
    if (this.model.ShipMode != null) {
      switch (catId) {
        case "CF":
          if (this.model.ShipMode.ShippingModeId == "PARC") return true;
          if (this.model.ShipMode.Incoterm == "FCA") return true;
          break;
        case "EF":
          if (this.model.ShipMode.ShippingModeId == "PARC") return true;
          if (this.model.ShipMode.Incoterm == "FCA") return true;
          break;
        case "TRIM":
          if (this.model.ShipMode.ShippingModeId == "PARC") return true;
          break;
      }
    }

    return false;
  }


  initCart() {

    let custName = this.model.accountInfo.FirstName + " " + this.model.accountInfo.LastName
    return {
      "CustomerID": "",
      "CustomerName": custName,
      "PO": "",
      "OrderDate": "",
      "SHIP_TYPE": "", //"Z1",
      "INCOTERMS1": "", //"CFR",
      "INCOTERMS2": "",
      "UserStatus": "", //"E0004", //TEMPLATE: E0002, QUOTE: E0003, ORDER: E0004
      "OrderItemCount": 0, //needs to be updated before Create
      "ShipToAddressLine1": "", //1435 WALTER ST",
      "ShipToAddressLine2": "", //"VENTURA",
      "ShipToCity": "", //"VENTURA",
      "RequestedDate": "", //"20161215",
      "ShipToContact": custName,
      "ShipToCountry": "", //"US",
      "ShipToRegion": "", //"CA",
      "ShipToPostalCode": "", //"93003",
      "ShipToPartnerID": "", //"50012",
      "ShipmentInstruction": "", //"pack it up nice",
      "JobName": "", //"job name",
      "ECommUser": "", //"50012_99",
      "DeliveryOptionId": "", //"10",
      "ShippingModeId": "", //"STD",
      "RoutePostfix": "",
      "CarrierName": "",
      "WillCall": "", // (this.currentShipTo.DeliveryOptions == "20") ? "X" : ""; 
      "ECommEmail": this.model.accountInfo.UserName, //"user@domain.com",
      "CutlistSet": [], //_.padStart('1000', 6, '0');
      "OrderItemSet": [],
      "metadata": {
        "attachments": [],
        "jobsiteAttachments": []
      }
      /*
      "OrderItemSet": [{
        "OfferingID": "0000001100",
        "Itemnumber": "001000",
        "Product": "SK12_P",
        "Materialnumber": "SK12_P",
        "Colorcode": "CHBC",
        "Gauge": "26",
        "CutlistProvide": "Y",
        "Productname": "12 Skyline Roofing®",
        "Metal": "ZNAL",
        "Grade": "",
        "PaintSystem": "DTXL",
        "UphillSlope": "",
        "DownhillSlope": "",
        "Requesteddelivery": "20161215",
        "Unitofmeasure": "SQ",
        "Quantity001": "1.000",
        "Plant": "MC03",
        "PackagingType": "STD"
      }, {
        "OfferingID": "",
        "Itemnumber": "002000",
        "Product": "V6_B_10",
        "Materialnumber": "V6_B_10",
        "Colorcode": "BARE",
        "Gauge": "22",
        "CutlistProvide": "T",
        "Productname": "W-VALLEY 42-15/16\" BARE (V6_B_10)",
        "Metal": "CR",
        "Grade": "40",
        "PaintSystem": "00",
        "UphillSlope": "9",
        "DownhillSlope": "NA",
        "Requesteddelivery": "20161215",
        "Unitofmeasure": "PC",
        "Quantity001": "5.000",
        "Plant": "MC03"
      }, {
        "OfferingID": "",
        "Itemnumber": "003000",
        "Product": "RIV1/8_BARE",
        "Materialnumber": "RIV1/8_BARE",
        "Colorcode": "BARE",
        "Gauge": "",
        "CutlistProvide": "B",
        "Productname": "1/8\" RIVET BARE (250CT) (RIV1/8_BARE)",
        "Metal": "",
        "Grade": "",
        "PaintSystem": "",
        "UphillSlope": "",
        "DownhillSlope": "",
        "Requesteddelivery": "20161215",
        "Unitofmeasure": "BAG",
        "Quantity001": "5.000",
        "Plant": "MC03"
      }
      ]*/
    }

    /*
    DeliveryOptionSet/ShippingMode:
        shipMode.DeliveryOptionId = cat.DeliveryOptionId;
        shipMode.Description = cat.Description;
        shipMode.ShippingModeId = mode.ShippingModeId;
        shipMode.ShippingType = mode.ShippingType;
        shipMode.Incoterm = mode.Incoterm;
        shipMode.Incoterm2 = mode.Incoterm2;
        shipMode.ParcelId = p.ParcelId;
        shipMode.ParcelName = p.Name;
        shipMode.Name = p.Name;
        shipMode.ShippingModeId = p.ShippingModeId;
        shipMode.RoutePostfix = p.RoutePostfix;
        shipMode.SortId = (int)System.Enum.Parse(typeof(ShippingSort), shipMode.ParcelId);
    */

  }

  openJobsiteModal() {
    alert("openJobsiteModal not implemented");
  }


  handlePricingError(psr) {
    if (psr.MessageText.length > 0) {
      this.toast("[" + psr.MessageType + "-" + psr.MessageCode + "] " + psr.MessageText);
    } else {
      switch (psr.MessageCode) {
        case "VM023":
          this.appRef.creditModalRef = this.showModal(this.appRef.creditModal, 'modal-dialog-centered', true);
          break;
        default:
          this.toast("[" + psr.MessageType + ":" + psr.MessageCode + "] " + " Pricing error, please contact your ASC BP Customer Service Representative");
          break;
      }
    }
  }

  chunkPanels() {
    let promoted = this.model.panels.filter((p: any) => { return p.PROMOTE; });
    let ef = promoted.filter((p: any) => { return p.PanelType == "EF" });
    let cf = promoted.filter((p: any) => { return p.PanelType == "CF" });


    let desc = `
      <span>
                <p>
                  
                  <strong>2½” Corrugated Bare (STOCK)</strong>
                </p>
                <span>
                  <span>2½” Corrugated is a traditional 24” wide corrugated roof or wall panel offering homeowners the traditional look of the homes dotting the countryside.</span>
                </span>
                <span>
                  <ul>
                    <li>
                      <span>
                        <strong>Gauge:</strong> 26
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Wall Coverage: </strong>24&quot;
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Roof Coverage: </strong>21<span>⅓</span>&quot;
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Rib Height: </strong>½&quot;
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Rib Spacing: </strong>2⅔&quot;
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Produced in: </strong>Anchorage, AK
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Available in stock lengths: </strong>8, 10, 12, 14, & 16 feet
                      </span>
                    </li>
                  </ul>
                </span>
              </span>

    `;

    let feat = `
<span>
              <ul>
                <li>
                  <span>Quick, economical trim packages available as standard trim pieces and can be ordered by part number. </span>
                </li>
                <li>
                  <span>26” gross width panel yields 24&quot; net wall coverage for wall applications and 21 1/3&quot; net roof coverage for roof applications. </span>
                </li>
                <li>
                  <span>Available in Zincalume® Plus finish for unpainted applications. </span>
                </li>
                <li>
                  <span>Matching fiberglass skylight panels are available. </span>
                </li>
                <li>
                  <span>
                    <span>2½” Corrugated panel assemblies are Class A Fire Rated when installed on non-combustible deck or framing per IBC or IRC. 2½” Corrugated panel assemblies are also Class A Fire Rated per UL790 when installed in accordance to UL listings. These UL assembles are also Class 4 Hail Rated. </span>
                  </span>
                </li>
              </ul>

            </span>

    `;

    ef.unshift({
      ACTIVE: false,
      BASE_UOM: "LF",
      CATEGORY_ID: "EF,AK03",
      CHANNEL_ID: "20",
      COATING: "B",
      CONV_FACTOR: "0.0000",
      Category: "EF - Exposed Fastener",
      CustomerGroup: "20 - BP",
      Description: desc,
      Features: feat,
      //ImageUrl: this.model.imageProxyUrl + "?contenttype=category&id=2_5C_PANELS",
      ImageUrl: "/cms/images/Category/2_5C_PANELS.gif",
      LengthDescription: "",
      MATERIAL_NUMBER: "2.5C26_BARE",
      MaxCutlistLength: (16 * 12),
      MinCutlistLength: (8 * 12),
      NAME: "2-1/2\" Corrugated Stock (BARE)",
      OFFERING_ID: "",
      PAINTSYSTEM: "",
      PLANT: "",
      PROFILE: "2.5C",
      PROMOTE: true,
      PaintSystem: "BARE",
      PanelType: "EF",
      Profile: "2.5C26_BARE",
      ProfileGroupId: "2.5C26_BARE",
      SALES_UOM: "",
      ShippingNotValid: "",
    });

    this.model.panelChunks = {
      "EF": this.chunk(ef, 2),
      "CF": this.chunk(cf, 2),
    };
  }

  cms(url: string) {
    if (url === undefined || url == null) return "";
    if (url.startsWith(this.API_ROOT)) return url;
    if (url.startsWith('data:image')) return this.sanitizer.bypassSecurityTrustResourceUrl(url);;

    if (url.startsWith('/cms')) {
      return this.API_ROOT + url;
    } else {
      return this.API_ROOT + '/cms' + url;
    }
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async waitDataLoaded(obj: any, propName: string, seconds: number) {
    for (let waitCount = 0; waitCount < seconds; waitCount++) {
      if (obj[propName] === undefined || obj[propName] == null || isEmpty(obj[propName])) {
        console.log("object property '" + propName + "' still not loaded, wait count: " + waitCount + "/" + seconds);
        await this.delay(1000);
      } else {
        console.log("object property '" + propName + "' is now loaded, wait ended!");
        return;
      }

    }
    console.log("object property '" + propName + "' still undefined, GIVING UP!");
  }


  async toast(msg, ms = 2000) {
    let toastParent = document.getElementById("toast");
    let newToast = document.createElement("div");
    let newId = this.UUID.generate();
    newToast.className = 'toast-msg box-shadow';
    newToast.innerHTML = msg;

    let newToastWrapper = document.createElement("div");
    newToastWrapper.setAttribute("id", newId);
    newToastWrapper.appendChild(newToast);
    toastParent.appendChild(newToastWrapper);

    await this.delay(ms);
    newToastWrapper.removeChild(newToast);
    toastParent.removeChild(newToastWrapper);
  }

  log(msg: string) {
    var logMsg = this.getDateStamp() + "\t" + msg;
    console.info(logMsg)
    this.runLog.push(logMsg);
  }
  debugWrite(...args: any[]) {
    if (typeof window == 'undefined') return;
    if (window['debugMode'] === null) return;
    if (window['debugMode'] === true) console.log.apply(this, args);
  }
  zoomImg(event) {
    this.model.imageZoomUrl = event.srcElement.src;
  }

  activeRouteIs(exactRoute: string) {
    return this.router.isActive(exactRoute, { paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored' });
  }
  /** 
    * Copies text to the clipboard - MUST BE CALLED FROM A CLICK HANDLER!
    * @param {string} text The text to be copied.
    */
  copyToClipboard(text) {
    //console.log(text);
    var dummy: HTMLTextAreaElement = document.createElement("textarea");
    dummy.className = "copytarget";
    document.body.appendChild(dummy);
    dummy.innerHTML = text;
    dummy.select();
    var success = document.execCommand("copy");
    document.body.removeChild(dummy);
    if (success) {
      this.toast("Clipboard updated!");
    } else {
      prompt("Automatic Copy to Clipboard failed, press Ctrl+C to copy", text);
    }
  }
  saveBlobAs(blob, fileName) {
    var url = window.URL.createObjectURL(blob);

    var anchorElem = document.createElement("a");
    anchorElem.style.display = "none";
    anchorElem.href = url;
    anchorElem.download = fileName;

    document.body.appendChild(anchorElem);
    anchorElem.click();

    document.body.removeChild(anchorElem);

    // On Edge, revokeObjectURL should be called only after
    // a.click() has completed, atleast on EdgeHTML 15.15048
    setTimeout(function () {
      window.URL.revokeObjectURL(url);
    }, 1000);
  }
  b64EncodeUnicode(str) {
    //https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
    }))
  }

  stripHtmlComments(content) {
    return content.replace(/<!--(?!>)[\S\s]*?-->/g, '');
  }
  currentDateTime() {
    let date = new Date();
    let year = date.getFullYear(),
      month = date.getMonth() + 1, // months are zero indexed
      day = date.getDate(),
      hour = date.getHours(),
      minute = date.getMinutes(),
      // second = date.getSeconds(),
      hourFormatted = hour % 12 || 12, // hour returned in 24 hour format
      minuteFormatted = minute < 10 ? "0" + minute : minute,
      morning = hour < 12 ? "am" : "pm";

    return month + "/" + day + "/" + year + " " + hourFormatted + ":" +
      minuteFormatted + morning;

  }
  getDateStamp() {
    var d = new Date();
    var h = addZero(d.getHours(), 2);
    var m = addZero(d.getMinutes(), 2);
    var s = addZero(d.getSeconds(), 2);
    var ms = addZero(d.getMilliseconds(), 3);
    var fullDate = h + ":" + m + ":" + s + ":" + ms;

    function addZero(x, n) {
      while (x.toString().length < n) {
        x = "0" + x;
      }
      return x;
    }

    return fullDate;
  }

  debounced(func, wait, immediate = false) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);
      if (immediate && !timeout) func.apply(context, args);
    };
  }

  circularStringify(o) {
    var cache = [];
    var result = JSON.stringify(o, (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (cache.indexOf(value) !== -1) {
          // Duplicate reference found
          try {
            // If this value does not reference a parent it can be deduped
            return JSON.parse(JSON.stringify(value, null, 4));
          } catch (error) {
            // discard key if value cannot be deduped
            return;
          }
        }
        // Store value in our collection
        cache.push(value);
      }
      return value;
    }, 4);
    cache = null; // Enable garbage collection
    return result;
  }

  hideFilters() {
    this.showFilters = (window.innerWidth > 768);
  }

  /**
   * Fast UUID generator, RFC4122 version 4 compliant.
   * @author Jeff Ward (jcward.com).
   * @license MIT license
   * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
  **/
  UUID = (() => {
    let lut = []; for (var i = 0; i < 256; i++) { lut[i] = (i < 16 ? '0' : '') + (i).toString(16); }
    return {
      generate: () => {
        let d0 = Math.random() * 0xffffffff | 0;
        let d1 = Math.random() * 0xffffffff | 0;
        let d2 = Math.random() * 0xffffffff | 0;
        let d3 = Math.random() * 0xffffffff | 0;
        return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
          lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
          lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
          lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
      }
    }
  })();

  scrollToElement(elementId) {
    setTimeout(() => {
      // angular actually seems to render multiple instances of a view that is conditionally shown
      // in two places, so we have to look for all of them!
      var elements = document.querySelectorAll('#' + elementId);
      elements.forEach((element: HTMLElement) => {
        console.log("scrollToElement: " + elementId);

        element.focus();
        if (typeof element['scrollIntoViewIfNeeded'] != "undefined") {
          console.log("using scrollIntoViewIfNeeded");
          element['scrollIntoViewIfNeeded'](); //non-chrome browsers use polyfill, above
        } else {
          console.log("using scrollIntoView");
          element.scrollIntoView();
        }
      });
    }, 500);

  }

  closestLowerHigherNr(nums, nr) {
    // JavaScript & jQuery Course - https://coursesweb.net/javascript/
    // Gets into an Array the values from "nums" array /object, and sorts from lowest to highest
    var vnums = [];
    for (var val in nums) vnums.push(val);
    vnums.sort(function (a, b) { return a - b; });

    var nr_vnums = vnums.length;      // number of elements in vnums

    // sets the object that will be returned, initially with the lowest and highest number from vnums
    var re_obj = { 'lower': Math.min(vnums[0], nr), 'higher': Math.max(vnums[nr_vnums - 1], nr), 'closest': nr };

    // traverse the numbers, stores in re_obj the number immediately lower and higher than nr
    for (var i = 0; i < nr_vnums; i++) {
      if (nr > vnums[i]) re_obj['lower'] = vnums[i];
      else if (nr <= vnums[i]) {
        // if the current number from vnums is equal to nr, or immediately higher, stores that number
        // and stops the for each() loop
        re_obj['higher'] = vnums[i];
        break;
      }
    }

    // here it gets the closest number to nr
    // (the number ('lower' or 'higher') with the lowest diferrence between its value and nr)
    re_obj['closest'] = (Math.abs(nr - re_obj['lower']) < Math.abs(re_obj['higher'] - nr)) ? re_obj['lower'] : re_obj['higher'];

    return re_obj;
  }


  MD5(s) {
    function L(k, d) {
      return (k << d) | (k >>> (32 - d))
    }

    function K(G, k) {
      var I,
        d,
        F,
        H,
        x;
      F = (G & 2147483648);
      H = (k & 2147483648);
      I = (G & 1073741824);
      d = (k & 1073741824);
      x = (G & 1073741823) + (k & 1073741823);
      if (I & d) {
        return (x ^ 2147483648 ^ F ^ H)
      }
      if (I | d) {
        if (x & 1073741824) {
          return (x ^ 3221225472 ^ F ^ H)
        } else {
          return (x ^ 1073741824 ^ F ^ H)
        }
      } else {
        return (x ^ F ^ H)
      }
    }

    function r(d, F, k) {
      return (d & F) | ((~d) & k)
    }

    function q(d, F, k) {
      return (d & k) | (F & (~k))
    }

    function p(d, F, k) {
      return (d ^ F ^ k)
    }

    function n(d, F, k) {
      return (F ^ (d | (~k)))
    }

    function u(G, F, aa, Z, k, H, I) {
      G = K(G, K(K(r(F, aa, Z), k), I));
      return K(L(G, H), F)
    }

    function f(G, F, aa, Z, k, H, I) {
      G = K(G, K(K(q(F, aa, Z), k), I));
      return K(L(G, H), F)
    }

    function D(G, F, aa, Z, k, H, I) {
      G = K(G, K(K(p(F, aa, Z), k), I));
      return K(L(G, H), F)
    }

    function t(G, F, aa, Z, k, H, I) {
      G = K(G, K(K(n(F, aa, Z), k), I));
      return K(L(G, H), F)
    }

    function e(G) {
      var Z;
      var F = G.length;
      var x = F + 8;
      var k = (x - (x % 64)) / 64;
      var I = (k + 1) * 16;
      var aa = Array(I - 1);
      var d = 0;
      var H = 0;
      while (H < F) {
        Z = (H - (H % 4)) / 4;
        d = (H % 4) * 8;
        aa[Z] = (aa[Z] | (G.charCodeAt(H) << d));
        H++
      }
      Z = (H - (H % 4)) / 4;
      d = (H % 4) * 8;
      aa[Z] = aa[Z] | (128 << d);
      aa[I - 2] = F << 3;
      aa[I - 1] = F >>> 29;
      return aa
    }

    function B(x) {
      var k = "",
        F = "",
        G,
        d;
      for (d = 0; d <= 3; d++) {
        G = (x >>> (d * 8)) & 255;
        F = "0" + G.toString(16);
        k = k + F.substr(F.length - 2, 2)
      }
      return k
    }

    function J(k) {
      k = k.replace(/rn/g, "n");
      var d = "";
      for (var F = 0; F < k.length; F++) {
        var x = k.charCodeAt(F);
        if (x < 128) {
          d += String.fromCharCode(x)
        } else {
          if ((x > 127) && (x < 2048)) {
            d += String.fromCharCode((x >> 6) | 192);
            d += String.fromCharCode((x & 63) | 128)
          } else {
            d += String.fromCharCode((x >> 12) | 224);
            d += String.fromCharCode(((x >> 6) & 63) | 128);
            d += String.fromCharCode((x & 63) | 128)
          }
        }
      }
      return d
    }
    var C = Array();
    var P,
      h,
      E,
      v,
      g,
      Y,
      X,
      W,
      V;
    var S = 7,
      Q = 12,
      N = 17,
      M = 22;
    var A = 5,
      z = 9,
      y = 14,
      w = 20;
    var o = 4,
      m = 11,
      l = 16,
      j = 23;
    var U = 6,
      T = 10,
      R = 15,
      O = 21;
    s = J(s);
    C = e(s);
    Y = 1732584193;
    X = 4023233417;
    W = 2562383102;
    V = 271733878;
    for (P = 0; P < C.length; P += 16) {
      h = Y;
      E = X;
      v = W;
      g = V;
      Y = u(Y, X, W, V, C[P + 0], S, 3614090360);
      V = u(V, Y, X, W, C[P + 1], Q, 3905402710);
      W = u(W, V, Y, X, C[P + 2], N, 606105819);
      X = u(X, W, V, Y, C[P + 3], M, 3250441966);
      Y = u(Y, X, W, V, C[P + 4], S, 4118548399);
      V = u(V, Y, X, W, C[P + 5], Q, 1200080426);
      W = u(W, V, Y, X, C[P + 6], N, 2821735955);
      X = u(X, W, V, Y, C[P + 7], M, 4249261313);
      Y = u(Y, X, W, V, C[P + 8], S, 1770035416);
      V = u(V, Y, X, W, C[P + 9], Q, 2336552879);
      W = u(W, V, Y, X, C[P + 10], N, 4294925233);
      X = u(X, W, V, Y, C[P + 11], M, 2304563134);
      Y = u(Y, X, W, V, C[P + 12], S, 1804603682);
      V = u(V, Y, X, W, C[P + 13], Q, 4254626195);
      W = u(W, V, Y, X, C[P + 14], N, 2792965006);
      X = u(X, W, V, Y, C[P + 15], M, 1236535329);
      Y = f(Y, X, W, V, C[P + 1], A, 4129170786);
      V = f(V, Y, X, W, C[P + 6], z, 3225465664);
      W = f(W, V, Y, X, C[P + 11], y, 643717713);
      X = f(X, W, V, Y, C[P + 0], w, 3921069994);
      Y = f(Y, X, W, V, C[P + 5], A, 3593408605);
      V = f(V, Y, X, W, C[P + 10], z, 38016083);
      W = f(W, V, Y, X, C[P + 15], y, 3634488961);
      X = f(X, W, V, Y, C[P + 4], w, 3889429448);
      Y = f(Y, X, W, V, C[P + 9], A, 568446438);
      V = f(V, Y, X, W, C[P + 14], z, 3275163606);
      W = f(W, V, Y, X, C[P + 3], y, 4107603335);
      X = f(X, W, V, Y, C[P + 8], w, 1163531501);
      Y = f(Y, X, W, V, C[P + 13], A, 2850285829);
      V = f(V, Y, X, W, C[P + 2], z, 4243563512);
      W = f(W, V, Y, X, C[P + 7], y, 1735328473);
      X = f(X, W, V, Y, C[P + 12], w, 2368359562);
      Y = D(Y, X, W, V, C[P + 5], o, 4294588738);
      V = D(V, Y, X, W, C[P + 8], m, 2272392833);
      W = D(W, V, Y, X, C[P + 11], l, 1839030562);
      X = D(X, W, V, Y, C[P + 14], j, 4259657740);
      Y = D(Y, X, W, V, C[P + 1], o, 2763975236);
      V = D(V, Y, X, W, C[P + 4], m, 1272893353);
      W = D(W, V, Y, X, C[P + 7], l, 4139469664);
      X = D(X, W, V, Y, C[P + 10], j, 3200236656);
      Y = D(Y, X, W, V, C[P + 13], o, 681279174);
      V = D(V, Y, X, W, C[P + 0], m, 3936430074);
      W = D(W, V, Y, X, C[P + 3], l, 3572445317);
      X = D(X, W, V, Y, C[P + 6], j, 76029189);
      Y = D(Y, X, W, V, C[P + 9], o, 3654602809);
      V = D(V, Y, X, W, C[P + 12], m, 3873151461);
      W = D(W, V, Y, X, C[P + 15], l, 530742520);
      X = D(X, W, V, Y, C[P + 2], j, 3299628645);
      Y = t(Y, X, W, V, C[P + 0], U, 4096336452);
      V = t(V, Y, X, W, C[P + 7], T, 1126891415);
      W = t(W, V, Y, X, C[P + 14], R, 2878612391);
      X = t(X, W, V, Y, C[P + 5], O, 4237533241);
      Y = t(Y, X, W, V, C[P + 12], U, 1700485571);
      V = t(V, Y, X, W, C[P + 3], T, 2399980690);
      W = t(W, V, Y, X, C[P + 10], R, 4293915773);
      X = t(X, W, V, Y, C[P + 1], O, 2240044497);
      Y = t(Y, X, W, V, C[P + 8], U, 1873313359);
      V = t(V, Y, X, W, C[P + 15], T, 4264355552);
      W = t(W, V, Y, X, C[P + 6], R, 2734768916);
      X = t(X, W, V, Y, C[P + 13], O, 1309151649);
      Y = t(Y, X, W, V, C[P + 4], U, 4149444226);
      V = t(V, Y, X, W, C[P + 11], T, 3174756917);
      W = t(W, V, Y, X, C[P + 2], R, 718787259);
      X = t(X, W, V, Y, C[P + 9], O, 3951481745);
      Y = K(Y, h);
      X = K(X, E);
      W = K(W, v);
      V = K(V, g)
    }
    var i = B(Y) + B(X) + B(W) + B(V);
    return i.toUpperCase()
  }

}
